<div class="object-picker-v2">
  <div
    class="d-flex align-items-center justify-content-between"
    [ngClass]="isTable ? 'border-bottom p-3 pb-2' : 'p-0 mb-2'"
  >
    <label class="m-0" [attr.for]="'typeahead-' + name">
      <div class="d-flex align-items-center gap-2">
        <b
          [ngClass]="{
          required: required,
          'h4 m-0': isTable
        }"
        >
          {{ title }}
        </b>

        <i
          *ngIf="isLoading"
          class="fa-regular fa-spinner fa-spin fa-fw text-muted"
          aria-label="Loading"
        ></i>
      </div>
    </label>

    <button
      *ngIf="fieldDefinition && !hideAddButton"
      type="button"
      class="btn btn-primary btn-sm"
      (click)="createNewObject()"
      #initialFocus
    >
      <label class="h-100 w-100 mb-0" style="cursor: pointer">
        <i class="fa-regular fa-plus fa-fw"></i>
        {{ 'shared.terms.new' | translate }}
      </label>
    </button>
  </div>

  <div
    *ngIf="isInitial && !hasConfigurationError"
    [ngClass]="isTable ? 'px-3 py-2' : ''"
  >
    {{ 'customData.selection' | translate }}
  </div>

  <div
    *ngIf="hasConfigurationError"
    class="text-danger"
    [ngClass]="isTable ? 'px-3 py-2' : ''"
  >
    {{ 'preferences.errors.missingDisplayFields' | translate }}
  </div>

  <div class="d-flex align-items-center w-100" [ngClass]="isTable ? 'p-3' : ''">
    <span class="mr-2 flex-shrink-0" *ngIf="isTable">
      {{ 'shared.terms.search' | translate }}:
    </span>

    <div class="flex-grow-1">
      <sh-autocomplete
        [items]="autoCompleteItems"
        (onSearch)="onSearch($event)"
        [itemLabel]="'__DisplayName'"
        [itemValue]="multiple ? null : '__Id'"
        (onChange)="onPick($event)"
        [placeholder]="placeholder"
        [minLength]="0"
        [isDisabled]="hasConfigurationError"
        [ngModel]="multiple ? null : searchModel"
        (ngModelChange)="multiple ? null : searchModel = $event"
      >
        <ng-template shTemplate="header">
          <div class="d-flex px-2 py-1 font-weight-bold border-bottom">
            <div
              *ngFor="let col of columns"
              class="text-truncate"
              [style.width.%]="100 / columns.length"
              [title]="col.name"
            >
              {{ col.name | translate }}
            </div>
          </div>
        </ng-template>

        <ng-template shTemplate="item" let-row>
          <div class="d-flex px-2 py-1">
            <div
              *ngFor="let col of columns"
              class="text-truncate"
              [style.width.%]="100 / columns.length"
              [title]="cellValue(row, col.key)"
            >
              {{ cellValue(row, col.key) }}
            </div>
          </div>
        </ng-template>
      </sh-autocomplete>
    </div>
  </div>

  <div
    class="object-picker-table mt-3"
    *ngIf="multiple && selectedItems.length"
  >
    <temp-table
      [model]="tableModel"
      [data]="{items: selectedItems}"
      [scrollable]="true"
      [tableStyle]="{ 'width': '100%' }"
    >
      <ng-template shTemplate="rowActions" let-row>
        <button type="button" class="btn btn-icon" (click)="removeItem(row)">
          <i class="fa-regular fa-trash fa-fw"></i>
        </button>
      </ng-template>
    </temp-table>
  </div>
</div>
